




interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    // ingredients: ingredients;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const bikinilaser: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} = {
    "en": {
        "url": "bikini-laser-hair-removal",
        "meta": {
            "title": "Bikini Laser Hair Removal Dubai | Elite Body Home",
            "description": "Safe, permanent bikini laser hair removal treatment for smooth, hair-free skin. Suitable for all skin types with minimal discomfort.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/bikini-laser-hair-removal/",
            "og": {
                "title": "Bikini Laser Hair Removal Dubai | Elite Body Home",
                "description": "Permanent hair reduction for bikini area with advanced laser technology",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/bikini-laser-hair-removal.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Bikini Laser Hair Removal"],
        "hero": {
            "title": "Bikini Laser Hair Removal Dubai",
            "subtitle": "Permanent Solution for Unwanted Hair",
            "description": "Do you hate unwanted hair in bikini area? Worry not! Here at Elite Body Home, we've got you covered. Shaving, waxing, threading, and epilating are all traditional methods that take time to do, are painful and only provide a temporary solution. What if I am talking about Bikini Laser Hair Removal in Dubai? Actually a permanent, gentle and perfect solution for removing unwanted hair bikini area. No more problems with living your private life."
        },
        "howItWorks": {
            "title": "How Is Bikini Laser Hair Removal Performed?",
            "description": "Bikini laser treatment is a simple process. Its initial use is to target and annihilate hair follicles using highly concentrated light beams. The laser sends pulses of light that are absorbed by the pigment in the hair, primarily destroying the follicle and inhibiting future hair growth. All this is thanks to advanced laser technology."
        },
        "procedureSteps": {
            "heading": "Bikini Laser Hair Removal Procedure Steps",
            "para": "Laser Bikini Hair Removal — A Fast, Efficient Way to Enjoy Hair-Free Skin The bikini line laser treatment precisely targets hair follicles using laser energy to prevent future hair growth. Here are the steps to be taken for lasting solutions.",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "Our specialists assess your skin and hair type to customize the treatment plan.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Preparation",
                    "desc": "The area is cleaned and prepared for treatment, with protective eyewear provided.",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "Laser Application",
                    "desc": "The laser device is carefully applied to target hair follicles while cooling technology ensures comfort.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Post-Treatment Care",
                    "desc": "Soothing creams are applied and aftercare instructions provided.",
                    "icon": "fa-solid fa-spa"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Bikini Laser Hair Removal",
            "subheading": "Why choose laser for intimate areas",
            "para": "Discovering the Major Benefits of Bikini Laser Hair Removal Treatment",
            "items": [
                {
                    "title": "Long-Lasting Results",
                    "desc": "While shaving or waxing, results last a few days but with laser hair removal results can last for months even years.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "Safe for Sensitive Areas",
                    "desc": "This is a non-invasive method and can be used on sensitive areas like bikini line and private parts.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "Fewer Ingrown Hairs",
                    "desc": "Another benefit of laser hair removal is less ingrown hair formation.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Comfortable Procedure",
                    "desc": "While bikini waxing and epilating can be painful, bikini laser hair removal is a more comfortable alternative.",
                    "icon": "fa-solid fa-smile"
                }
            ]
        },
        "eligibility": {
            "heading": "Who is a good candidate?",
            "subheading": "",
            "para": "To be eligible for bikini laser hair removal to be safe and effective, you should fall under the criteria:",
            "items": [
                {
                    "title": "Ideal Skin and Hair Type",
                    "desc": "Best suited for those who have dark hair and fair to medium skin.",
                    "icon": "fa-solid fa-palette"
                },
                {
                    "title": "Healthy Skin Condition",
                    "desc": "The bikini should not have infections, open wounds, or irritations.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "Not Pregnant or Breastfeeding",
                    "desc": "While hormonal shifts from pregnancy or breastfeeding can change results, laser based hair removal is typically not recommended during pregnancy or breastfeeding.",
                    "icon": "fa-solid fa-baby"
                },
                {
                    "title": "No Recent Tanning",
                    "desc": "Refrain from sun exposure or tanning beds at least two weeks prior to the treatment to reduce skin sensitivity.",
                    "icon": "fa-solid fa-sun"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation Before Treatment",
            "subheading": "",
            "para": "Preparation is the key to getting the best results. Here are the parameters:",
            "items": [
                {
                    "title": "Shave the Area",
                    "desc": "Shave before you do so with a mild razor and shaving oil to minimize irritation. Hold the skin tight for a closer shave in sensitive places such as the labia.",
                    "icon": "fa-solid fa-cut"
                },
                {
                    "title": "Avoid Sun Exposure",
                    "desc": "Do not expose the treated area to the sun for at least two weeks before the treatment to avoid activating any possible sensitivity.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "Avoid Other Hair Removal Methods",
                    "desc": "Four weeks before your treatment, avoid waxing and/or threading and/or plucking from the bikini area because the laser needs to target an intact hair follicle.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Clean Skin",
                    "desc": "Arrive with clean, product-free skin in the treatment area.",
                    "icon": "fa-solid fa-broom"
                }
            ]
        },
        "results": {
            "heading": "Expected Results",
            "subheading": "",
            "para": "One of the reasons bikini laser hair removal is so popular among women in Dubai is because of the results. Here are the basic results you can get after the treatment:",
            "items": [
                {
                    "title": "Significant Hair Reduction",
                    "desc": "After 4 to 6 sessions most clients see hair reduction. The hair that emerges is finer, lighter and less dense.",
                    "icon": "fa-solid fa-chart-line-down"
                },
                {
                    "title": "Long-Lasting Smoothness",
                    "desc": "Once the treatment is completed, it leaves you with smooth, hair-less skin for months, even years. Occasional follow-up treatments may be needed to maintain results.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "No More Ingrown Hairs",
                    "desc": "Since its not a method like waxing or shaving therefore, prevent ingrowth.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Improved Skin Texture",
                    "desc": "Laser treatments can also promote a smoother, more even appearance to the skin in the bikini area, as they can reduce irritation and discoloration resulting from traditional methods.",
                    "icon": "fa-solid fa-spa"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Instructions",
            "subheading": "",
            "para": "To be able to preserve the healing and the result received, it is necessary to do aftercare after the treatment. To prevent any unnecessary issues, follow these steps:",
            "items": [
                {
                    "title": "Avoid Heat",
                    "desc": "Steer clear of hot tubs and saunas, as well as rigorous workouts, for 48 hours.",
                    "icon": "fa-solid fa-fire-alt"
                },
                {
                    "title": "Use Gentle Products",
                    "desc": "Stay away from harsh soaps or exfoliants in the bikini area for the first few days.",
                    "icon": "fa-solid fa-pump-soap"
                },
                {
                    "title": "Moisturize Regularly",
                    "desc": "Use aloe vera or moisturizer recommended by a dermatologist.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "Sun Protection",
                    "desc": "Use sunscreen when treated area is going to get direct sun exposure to prevent sensitivity or being heated up.",
                    "icon": "fa-solid fa-sun"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "Common questions about bikini laser hair removal",
            "items": [
                {
                    "question": "Is bikini laser hair removal safe for sensitive skin?",
                    "answer": "Yes, our advanced laser technology is safe for all skin types including sensitive skin in the bikini area."
                },
                {
                    "question": "How many sessions will I need?",
                    "answer": "Most clients need 6-8 sessions spaced 4-6 weeks apart for optimal results."
                },
                {
                    "question": "Does the treatment hurt?",
                    "answer": "Most clients report only mild discomfort thanks to our cooling technology during treatment."
                },
                {
                    "question": "When will I see results?",
                    "answer": "You'll notice gradual reduction after each session, with significant results after 3-4 treatments."
                },
                {
                    "question": "Can I shave between sessions?",
                    "answer": "Yes, shaving is allowed between treatments but avoid waxing or plucking."
                },
                {
                    "question": "Is there any downtime?",
                    "answer": "No, you can resume normal activities immediately after treatment."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/New-Service-Banner-Image-3dgs.jpg",
            "beforeAfter": [

            ]
        },
        "product": {
            "id": 49,
            "title": "Bikini Laser Hair Removal",
            "description": "Permanent hair reduction for bikini area with advanced laser technology",
            "price": 800
        }
    },
    "ar": {
        "url": "bikini-laser-hair-removal",
        "meta": {
            "title": "إزالة شعر البكيني بالليزر في دبي | ايليت بودي هوم",
            "description": "علاج آمن ودائم لإزالة شعر البكيني بالليزر للحصول على بشرة ناعمة خالية من الشعر. مناسب لجميع أنواع البشرة مع حد أدنى من الانزعاج.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/bikini-laser-hair-removal",
            "og": {
                "title": "إزالة شعر البكيني بالليزر في دبي | ايليت بودي هوم",
                "description": "تقليل الشعر بشكل دائم لمنطقة البكيني بتقنية الليزر المتقدمة",
                "image": "https://www.elitebodyhome.com/images/bikini-laser-og.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "إزالة شعر البكيني بالليزر"],
        "hero": {
            "title": "إزالة شعر البكيني بالليزر في دبي",
            "subtitle": "حل دائم للشعر غير المرغوب فيه",
            "description": "هل سئمت من الشعر غير المرغوب فيه في منطقة البكيني؟ لا داعي للقلق! نقدم لكِ في ايليت بودي هوم الحل الأمثل، فالطرق التقليدية مثل الحلاقة، أو الشمع، أو الخيط، أو أجهزة نزع الشعر تستغرق وقتًا طويلاً ومؤلمة، كما أنها لا توفر سوى حلول مؤقتة. ماذا عن إزالة شعر بالليزر لمنطقة البكيني في دبي؟ تُعد طريقة آمنة وفعالة للتخلص من الشعر غير المرغوب فيه بشكل دائم، لتنعمي ببشرة ناعمة براحة تامة!"
        },
        "howItWorks": {
            "title": "كيف يتم إزالة شعر بالليزر لمنطقة البكيني؟",
            "description": "تعتبر إزالة الشعر بالليزر للمنطة الحساسة عملية بسيطة وفعالة، حيث تُوجه أشعة ضوئية مركزة لتدمير جذر بصيلة الشعر، مما يؤدي منع نمو الشعر مستقبلاً، وذلك بفضل تقنية الليزر المتطورة، التي توفر نتائج فعالة ودائمة."
        },
        "procedureSteps": {
            "heading": "خطوات إجراء إزالة الشعر بالليزر لمنطقة البكيني",
            "para": "تعد إزالة الشعر البكيني بالليزر وسيلة سريعة وفعالة للحصول على بشرة ناعمة وخالية من الشعر، حيث يستهدف الليزر بصيلات الشعر بدقة عالية لمنع نموها مرة أخرى. ويجب اتباع خطوات مُحددة للحصول على نتائج تدوم طويلاً.",
            "steps": [
                {
                    "title": "استشارة الطبيب",
                    "desc": "يقوم أخصائينا بتقييم نوع بشرتك وشعرك لوضع خطة علاج مخصصة.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "التحضير",
                    "desc": "يتم تنظيف المنطقة وتحضيرها للعلاج، مع توفير نظارات واقية.",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "تطبيق الليزر",
                    "desc": "يتم تطبيق جهاز الليزر بعناية لاستهداف بصيلات الشعر مع ضمان الراحة عبر تقنية التبريد.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "العناية بعد العلاج",
                    "desc": "يتم تطبيق كريمات مهدئة وتقديم إرشادات العناية اللاحقة.",
                    "icon": "fa-solid fa-spa"
                }
            ]
        },
        "benefits": {
            "heading": "مزايا إزالة الشعر بالليزر لمنطقة البكيني",
            "subheading": "لماذا تختار الليزر للمناطق الحساسة",
            "para": "مزايا إزالة الشعر بالليزر لمنطقة البكيني",
            "items": [
                {
                    "title": "نتائج طويلة الأمد",
                    "desc": "توفر إزالة الشعر بالليزر نتائج تدوم لعدة أشهر، وأحيانًا لسنوات على عكس الحلاقة أو الشمع.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "إجراء آمن للمناطق الحساسة",
                    "desc": "يتميز هذا الإجراء إنه غير جراحي وآمن تمامًا للمناطق الحساسة مثل خط البكيني والمناطق الخاصة.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "تقليل نمو الشعر تحت الجلد",
                    "desc": "يقلل الليزر مشكلة نمو الشعر تحت الجلد بشكل كبير، والتي تعتبر شائعة نتيجة لطرق إزالة الشعر التقليدية.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "إجراء مريح",
                    "desc": "يعد إزالة الشعر بالليزر أقل ألمًا من الشمع أو أجهزة إزالة الشعر الكهربائية، مما يجعله خيارًا مريحًا وفعالًا.",
                    "icon": "fa-solid fa-smile"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية",
            "subheading": "",
            "para": "يجب استيفاء المعايير التالية قبل الخضوع لجلسات إزالة الشعر البكيني بالليزر لضمان علاج آمن وفعال:",
            "items": [
                {
                    "title": "نوع البشرة ولون الشعر المناسب",
                    "desc": "يكون العلاج أكثر فعالية للأشخاص ذوي الشعر الداكن والبشرة الفاتحة إلى المتوسطة.",
                    "icon": "fa-solid fa-palette"
                },
                {
                    "title": "حالة جلد صحية",
                    "desc": "يجب أن تكون منطقة البكيني خالية من الالتهابات أو الجروح المفتوحة.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "لا تناسب الحامل والمُرضعة",
                    "desc": "لا يُنصح بإزالة الشعر بالليزر للنساء الحوامل أو المرضعات، لأن التغيرات الهرمونية قد تؤثر على النتائج.",
                    "icon": "fa-solid fa-baby"
                },
                {
                    "title": "تجنب جلسات التان",
                    "desc": "يُفضل تجنب التعرض المباشر للشمس أو استخدام أجهزة التان لمدة لا تقل عن أسبوعين قبل الجلسة لتفادي حساسية الجلد.",
                    "icon": "fa-solid fa-sun"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد قبل الجلسة",
            "subheading": "",
            "para": "يُعد التحضير المسبق خطوة أساسية لضمان الحصول على أفضل النتائج. إليك بعض الإرشادات المهمة:",
            "items": [
                {
                    "title": "حلاقة المنطقة",
                    "desc": "استخدمي شفرة حلاقة ناعمة وزيت الحلاقة لتجنب التهيج، واحرصي على شد الجلد للحصول على حلاقة أكثر دقة، خاصة في المناطق الحساسة مثل الشفرتين.",
                    "icon": "fa-solid fa-cut"
                },
                {
                    "title": "تجنب التعرض لأشعة الشمس",
                    "desc": "يُفضل تجنب التعرض المباشر للشمس لمدة لا تقل عن أسبوعين قبل الجلسة لتفادي حساسية الجلد.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "تجنب طرق إزالة الشعر التقليدية",
                    "desc": "لا تستخدمي الشمع أو الخيط أو الملقط في منطقة البكيني لمدة أربعة أسابيع قبل الجلسة، لضمان بقاء بصيلات الشعر سليمة ليستهدفها الليزر بشكل فعال.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "بشرة نظيفة",
                    "desc": "احرصي على أن تكون منطقة العلاج نظيفة وخالية من المنتجات.",
                    "icon": "fa-solid fa-broom"
                }
            ]
        },
        "results": {
            "heading": "النتائج المتوقعة",
            "subheading": "",
            "para": "تُعد نتائج المريحة لإزالة الشعر بالليزر لمنطقة البكيني من الأسباب الرئيسية لشعبيته بين النساء في دبي.",
            "items": [
                {
                    "title": "انخفاض ملحوظ في نمو الشعر",
                    "desc": "يلاحظ معظم العملاء انخفاضًا في معدل نمو الشعر بعد 4 إلى 6 جلسات، حيث يصبح الشعر المُعالج أنعم، وأفتح لونًا، وأقل كثافة.",
                    "icon": "fa-solid fa-chart-line-down"
                },
                {
                    "title": "نعومة طويلة الأمد",
                    "desc": "يوفر العلاج بشرة ناعمة وخالية من الشعر لعدة أشهر أو حتى سنوات، مع الحاجة إلى جلسات متابعة نادرة للحفاظ على النتائج.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "لا مزيد من الشعر النامي تحت الجلد",
                    "desc": "يساعد الليزر في منع مشكلة الشعر النامي تحت الجلد، والتي تعتبر شائعة مع طرق إزالة الشعر التقليدية مثل الشمع أو الحلاقة.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "تحسن ملمس البشرة",
                    "desc": "يساعد الليزر في تحسين ملمس البشرة وتوحيد لونها، من خلال تقليل التهيج والتصبغات الناتجة عن الطرق التقليدية.",
                    "icon": "fa-solid fa-spa"
                }
            ]
        },
        "aftercareTips": {
            "heading": "إرشادات العناية بعد الجلسة",
            "subheading": "",
            "para": "يجب اتباع إرشادات العناية بعد الجلسة للحفاظ على نتائج العلاج وضمان تعافي البشرة بشكل صحيح.",
            "items": [
                {
                    "title": "تجنب الحرارة",
                    "desc": "ابتعدي عن أحواض الماء الساخن، والساونا، والتمارين المكثفة لمدة 48 ساعة بعد الجلسة.",
                    "icon": "fa-solid fa-fire-alt"
                },
                {
                    "title": "استخدام منتجات لطيفة",
                    "desc": "تجنبي استخدام الغسول القاسي أو المقشرات في منطقة البكيني لعدة أيام للحفاظ على راحة البشرة.",
                    "icon": "fa-solid fa-pump-soap"
                },
                {
                    "title": "الترطيب المنتظم",
                    "desc": "استخدمي چل الصبار أو مرطب موصى به من قبل طبيب الجلدية لتهدئة المنطقة المعالجة.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "الحماية من الشمس",
                    "desc": "إذا تعرضت المنطقة لأشعة الشمس، احرصي على استخدام واقي شمسي مناسب لتجنب الحساسية أو الاحمرار الناتج عن الحرارة.",
                    "icon": "fa-solid fa-sun"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة المتكررة",
            "subheading": "أسئلة شائعة حول إزالة شعر البكيني بالليزر",
            "items": [
                {
                    "question": "هل إزالة شعر البكيني بالليزر آمنة للبشرة الحساسة؟",
                    "answer": "نعم، تقنية الليزر المتقدمة لدينا آمنة لجميع أنواع البشرة بما في ذلك البشرة الحساسة في منطقة البكيني."
                },
                {
                    "question": "كم عدد الجلسات التي سأحتاجها؟",
                    "answer": "معظم العملاء يحتاجون إلى 6-8 جلسات بفاصل 4-6 أسابيع للحصول على أفضل النتائج."
                },
                {
                    "question": "هل العلاج مؤلم؟",
                    "answer": "يذكر معظم العملاء شعورًا بعدم الراحة البسيط بفضل تقنية التبريد أثناء العلاج."
                },
                {
                    "question": "متى سأرى النتائج؟",
                    "answer": "ستلاحظين انخفاضًا تدريجيًا بعد كل جلسة، مع نتائج ملحوظة بعد 3-4 جلسات."
                },
                {
                    "question": "هل يمكنني الحلاقة بين الجلسات؟",
                    "answer": "نعم، يُسمح بالحلاقة بين الجلسات ولكن يجب تجنب الشمع أو النتف."
                },
                {
                    "question": "هل هناك فترة نقاهة؟",
                    "answer": "لا، يمكنك استئناف أنشطتك الطبيعية مباشرة بعد العلاج."
                }
            ]
        }
    }
}